// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RV3UVNx1gNEnMX5E2OPw .d11gqDGtojom9ZyPdHQj{padding:11px 8px 11px 11px}.RV3UVNx1gNEnMX5E2OPw .kfGtT5sgVcgHTKoVbCJ4{margin-left:4px;padding:0;font-size:13px}.hVkTbd1Oglke3aOstkx6{margin-right:10px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `RV3UVNx1gNEnMX5E2OPw`,
	"select": `d11gqDGtojom9ZyPdHQj`,
	"link": `kfGtT5sgVcgHTKoVbCJ4`,
	"labelText": `hVkTbd1Oglke3aOstkx6`
};
export default ___CSS_LOADER_EXPORT___;
